import { ArrowUp } from '../../components/ui/icons';
import { FB_BASE } from './constants';

// ── Step 4 · Confidence ───────────────────────────────────────────────────────
export function ConfidenceCard() {
  return (
    <div className="relative overflow-hidden rounded-[24px] bg-[radial-gradient(125%_95%_at_82%_-12%,#19311F_0%,#10131A_48%,#07070B_100%)] p-[22px] shadow-[0_30px_56px_-24px_rgba(0,0,0,0.6)]">
      <div className="pointer-events-none absolute -right-[60px] -top-[70px] h-[230px] w-[230px] rounded-full bg-[radial-gradient(circle,rgba(36,197,106,0.30),transparent_70%)]" />
      <div className="relative">
        <div className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-accent/[0.16] px-[11px] py-[5px]">
          <span className="h-[6px] w-[6px] animate-h2h-pulse rounded-full bg-accent" />
          <span className="num text-[12px] font-extrabold tracking-snug text-white">ARS 2–1 TOT</span>
          <span className="num text-[10px] font-extrabold text-accent">71'</span>
        </div>

        <div className="mt-[18px] flex items-baseline gap-[10px]">
          <span className="num text-[52px] font-extrabold leading-none tracking-tight text-white">
            +165
          </span>
          <div className="flex items-center gap-[3px] rounded-lg bg-accent/16 px-2 py-1">
            <ArrowUp width={12} height={12} strokeWidth={3.5} className="text-accent" />
            <span className="text-[12px] font-extrabold text-accent">to win</span>
          </div>
        </div>

        <div className="mt-[18px] flex items-center gap-3 rounded-[16px] border border-white/[0.09] bg-white/[0.06] px-[15px] py-[13px]">
          <div className="flex items-baseline gap-px rounded-[10px] bg-white px-[9px] py-[5px]">
            <span className="text-[11px] font-extrabold text-[#6E6E73]">×</span>
            <span className="num text-[16px] font-extrabold leading-none text-ink">3.3</span>
          </div>
          <div className="flex-1">
            <div className="text-[13px] font-bold tracking-snug text-white">Boost stack</div>
            <div className="mt-px text-[11px] font-medium text-white/55">
              Multiplies your {FB_BASE}-point base — bust to −{FB_BASE} if the result misses
            </div>
          </div>
        </div>

        <div className="mt-[14px] flex items-center gap-[10px]">
          <div className="flex flex-1 gap-[5px]">
            <span className="h-[5px] flex-1 rounded-[3px] bg-accent" />
            <span className="h-[5px] flex-1 rounded-[3px] bg-accent" />
            <span className="h-[5px] flex-1 rounded-[3px] bg-accent" />
            <span className="h-[5px] flex-1 rounded-[3px] bg-white/14" />
          </div>
          <span className="whitespace-nowrap text-[11px] font-semibold text-white/55">
            Base + 3 boosts
          </span>
        </div>
      </div>
    </div>
  );
}
